
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import businessService from './businessService'

const initialState = {
    businesss: [],
    business: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
    listLoading: false,
    listError: false,
    listMessage: '',
    updateLoading: false,
    updateError: false,
    updateMessage: '',
    createLoading: false,
    createError: false,
    createMessage: ''
}

export const businessSlice = createSlice({
    name: 'business',
    initialState,
    reducers: {
        reset: (state) => initialState,
        setBusinessActiveOptimistic: (state, action) => {
            const { id, businessState, updatedAt } = action.payload || {};
            const target = state.businesss.find((biz) => (biz.id || biz.businessId) === id);
            if (target) {
                target.businessState = businessState;
                if (updatedAt) target.updatedAt = updatedAt;
            }
        },
        revertBusinessActive: (state, action) => {
            const { id, prevBusinessState } = action.payload || {};
            const target = state.businesss.find((biz) => (biz.id || biz.businessId) === id);
            if (target) {
                target.businessState = prevBusinessState;
            }
        }
    },
    extraReducers: (builder) => {
        builder


            .addCase(getBusiness.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getBusiness.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.business = action.payload
            })
            .addCase(getBusiness.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            .addCase(getMyBusiness.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getMyBusiness.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.business = action.payload
            })
            .addCase(getMyBusiness.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            .addCase(updateMyBusiness.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateMyBusiness.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.business = action.payload
            })
            .addCase(updateMyBusiness.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            .addCase(createBusiness.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createBusiness.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.business = action.payload
            })
            .addCase(createBusiness.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            // uploadBusinessCatalog
            .addCase(uploadBusinessCatalog.pending, (state) => {
                state.isLoading = true
            })
            .addCase(uploadBusinessCatalog.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.business = action.payload
            })
            .addCase(uploadBusinessCatalog.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            // uploadBusinessThumbnail
            .addCase(uploadBusinessThumbnail.pending, (state) => {
                state.isLoading = true
            })
            .addCase(uploadBusinessThumbnail.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.business = action.payload
            })
            .addCase(uploadBusinessThumbnail.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            .addCase(listBusinesses.pending, (state) => {
                state.listLoading = true
                state.listError = false
                state.listMessage = ''
            })
            .addCase(listBusinesses.fulfilled, (state, action) => {
                state.listLoading = false
                state.listError = false
                state.businesss = action.payload
            })
            .addCase(listBusinesses.rejected, (state, action) => {
                state.listLoading = false
                state.listError = true
                state.listMessage = action.payload
            })

            .addCase(updateBusinessActive.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(updateBusinessActive.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const updated = action.payload
                const target = state.businesss.find((biz) => (biz.id || biz.businessId) === updated?.id)
                if (target) {
                    Object.assign(target, updated)
                }
            })
            .addCase(updateBusinessActive.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
                const { id, prevBusinessState } = action.meta?.arg || {}
                if (id !== undefined && prevBusinessState !== undefined) {
                    const target = state.businesss.find((biz) => (biz.id || biz.businessId) === id)
                    if (target) {
                        target.businessState = prevBusinessState
                    }
                }
            })

            .addCase(updateBusinessById.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(updateBusinessById.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const updated = action.payload
                const target = state.businesss.find((biz) => (biz.id || biz.businessId) === updated?.id)
                if (target) {
                    Object.assign(target, updated)
                }
            })
            .addCase(updateBusinessById.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
            })

            .addCase(deleteBusinessById.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(deleteBusinessById.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const deletedId = action.payload?.id
                if (deletedId) {
                    state.businesss = state.businesss.filter((biz) => (biz.id || biz.businessId) !== deletedId)
                }
            })
            .addCase(deleteBusinessById.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
            })

            .addCase(createBusinessByAdmin.pending, (state) => {
                state.createLoading = true
                state.createError = false
                state.createMessage = ''
            })
            .addCase(createBusinessByAdmin.fulfilled, (state) => {
                state.createLoading = false
                state.createError = false
            })
            .addCase(createBusinessByAdmin.rejected, (state, action) => {
                state.createLoading = false
                state.createError = true
                state.createMessage = action.payload
            })
    }
})



export const createBusiness = createAsyncThunk('event/createBusiness', async (businessData, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid
        return await businessService.createBusiness(businessData, userId)
    } catch (error) {
        const message = error.message;
        console.log("createBusinessError: " + message);
        return thunkAPI.rejectWithValue(message);
    }
})

export const getBusiness = createAsyncThunk('business/getBusiness', async (businessId, thunkAPI) => {
    try {
        return await businessService.getBusiness(businessId)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const getMyBusiness = createAsyncThunk('business/getMyBusiness', async (_, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid
        console.log("getBusiness userId: " + userId);
        return await businessService.getMyBusiness(userId)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateMyBusiness = createAsyncThunk('business/updateMyBusiness', async (businessData, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid
        return await businessService.updateMyBusiness(businessData, userId)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const uploadBusinessCatalog = createAsyncThunk('business/uploadBusinessCatalog', async (file, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid
        return await businessService.uploadBusinessCatalog(file, userId)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const uploadBusinessThumbnail = createAsyncThunk('business/uploadBusinessThumbnail', async (file, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid
        return await businessService.uploadBusinessThumbnail(file, userId)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const listBusinesses = createAsyncThunk('business/listBusinesses', async (_, thunkAPI) => {
    try {
        return await businessService.listBusinesses()
    } catch (error) {
        const message = error?.message || 'Firmalar yüklenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateBusinessActive = createAsyncThunk('business/updateBusinessActive', async ({ id, businessState }, thunkAPI) => {
    try {
        return await businessService.updateBusinessActive(id, businessState)
    } catch (error) {
        const message = error?.message || 'Firma durumu güncellenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateBusinessById = createAsyncThunk('business/updateBusinessById', async ({ id, data }, thunkAPI) => {
    try {
        return await businessService.updateBusinessById(id, data)
    } catch (error) {
        const message = error?.message || 'Firma güncellenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteBusinessById = createAsyncThunk('business/deleteBusinessById', async ({ id }, thunkAPI) => {
    try {
        return await businessService.deleteBusinessById(id)
    } catch (error) {
        const message = error?.message || 'Firma silinemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const createBusinessByAdmin = createAsyncThunk('business/createBusinessByAdmin', async (payload, thunkAPI) => {
    try {
        return await businessService.createBusinessByAdmin(payload)
    } catch (error) {
        const message = error?.message || 'Firma oluşturulamadı.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateBusinessUsers = createAsyncThunk('business/updateBusinessUsers', async ({ id, users }, thunkAPI) => {
    try {
        return await businessService.updateBusinessUsers(id, users)
    } catch (error) {
        const message = error?.message || 'Firma kullanıcıları güncellenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const { reset, setBusinessActiveOptimistic, revertBusinessActive } = businessSlice.actions
export const selectBusinesses = (state) => state.business.businesss
export const selectBusinessesLoading = (state) => state.business.listLoading
export const selectBusinessesError = (state) => state.business.listError
export const selectBusinessesMessage = (state) => state.business.listMessage
export const selectBusinessesUpdateError = (state) => state.business.updateError
export const selectBusinessesUpdateMessage = (state) => state.business.updateMessage
export const selectBusinessesCreateLoading = (state) => state.business.createLoading
export const selectBusinessesCreateError = (state) => state.business.createError
export const selectBusinessesCreateMessage = (state) => state.business.createMessage
export default businessSlice.reducer
